export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry-49ce4e4773e8763bc7a2.worker.js");
}
